import tw from 'twin.macro';
import { useEffect, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { XIcon } from '@heroicons/react/solid';
import Image from 'next/image';
import { getSocialLinksByCourseID } from '../../../lib/api/socialLinks';
import { getStandAlonePageProps, getStandAlonePageData } from '../../../lib/api/masterClass';
import { useRouter } from 'next/router';
import MasterClassContainer from '../container';
import { handleDataTracker } from '../tracker';

const CloseButton = tw.button`
  border-transparent
  outline-none
  z-50
`;

const DialogContainer = tw.div`
fixed
inset-0
bg-black
bg-opacity-25
transition-opacity
`;
const Popup = tw.div`
relative
inline-block
bg-white
rounded-t-[3px] 
md:rounded-xl
px-1
pt-1
text-left
overflow-hidden
shadow-xl
transform
transition-all
sm:my-8  
sm:px-4
sm:pt-4
`;

const PopupContainer = tw.div`
flex
md:items-center
items-end
justify-center
min-h-screen
text-center
`;

const Overlay = tw.div`
      fixed inset-0 bg-black bg-opacity-50 transition-opacity
  `;

const ButtonContainer = tw.div`
absolute
top-0
right-0
pt-4
pr-4
`;

const Container = tw.div`
    text-center
`;

const SuccessIcon = tw.div`
    flex justify-center items-center
`;

const HeadingContainer = tw.div`
    text-center mb-3 inline-block 
`;
const Heading = tw.h4`
    font-bold md:text-[20px] md:leading-[26px]  text-[14px] leading-[21px] mb-4
`;
const SubHeading = tw.p``;
const SocialContainer = tw.div`flex   sm:justify-center sm:items-center gap-5`;
const SocialText = tw.p``;
const IconContainer = tw.div`
    flex justify-center  py-[3px] gap-x-4
`;

const SuccessPopup = ({ contentSelected, isOpen, setOpen, sectionName }) => {
  let [linkedin, setLinkedin] = useState('');
  let [telegram, setTelegram] = useState('');
  let [whatsappLink, setWhatsappLink] = useState('');
  const { asPath, pathname, query } = useRouter();

  useEffect(() => {
    const storedValues = localStorage.getItem('formData');
    const leadLocationData = localStorage.getItem('leadLocation');
    const countryId = JSON.parse(leadLocationData)?.country;

    // get Countries List
    async function getSocialLinks() {
      let response = await getStandAlonePageData(`master-class/${query.slug}`);
      if (response[0]) {
        if (countryId == 4) {
          setWhatsappLink(response[0].whatsAppJoinLinkIndia);
        } else {
          setWhatsappLink(response[0].whatsAppJoinLinkOtherIndia);
        }
        setTelegram(response[0].telegramURL);
        setLinkedin(response[0].linkedInURL);
      }
    }

    getSocialLinks();
  }, []);

  // close
  const close = () => {
    setOpen(false);
    document.body.style.overflow = 'auto';
  };
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    }
  }, [isOpen]);

  return (
    <div className="absolute">
      <Transition.Root show={isOpen}>
        <div className="fixed z-[200] inset-0 overflow-y-auto">
          <MasterClassContainer>
            <PopupContainer className="flex md:items-center items-end justify-center text-center sm:block sm:p-0">
              <Transition.Child
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Overlay onClick={close} />
              </Transition.Child>

              <Transition.Child
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Popup
                  className={`${
                    whatsappLink
                      ? 'sm:w-[1042px] sm:h-[445px] w-full'
                      : 'sm:w-[548px] sm:px-[30px] sm:pt-[27px] sm:pb-[20px] px-[17px] pt-[37px] pb-[49px]'
                  } -mb-[6px] md:mb-0`}
                >
                  <div
                    className={` ${
                      whatsappLink ? 'md:hidden  block top-2 right-2' : 'block top-[18px] right-[18px]'
                    } absolute  z-10 cursor-pointer`}
                    onClick={close}
                  >
                    <XIcon className={`w-4 ${whatsappLink ? 'text-white' : 'text-black'} `} />
                  </div>
                  <Container>
                    {whatsappLink && (
                      <div className=" rounded bg-[#DB4144] text-white px-3 md:px-0 py-4 md:py-6">
                        <div className="sm:flex hidden  gap-9 items-center">
                          <div className="ml-[46px]  gap-4 flex items-center">
                            <div>
                              <img
                                src={'https://d2o2utebsixu4k.cloudfront.net/master-class/whatsappMasterClass.png'}
                                width="64"
                                height="64"
                                alt="whatsapp"
                              />
                            </div>
                            <div>
                              <div className="text-left text-3xl mb-3 font-bold  ">Join our WhatsApp Community</div>
                              <div className=" text-lg text-left leading-[21px">
                                Get <span className="bg-white text-base leading-[22px] text-black skew ">Free</span>{' '}
                                learning resources, course offers, newsletters, updates and future events
                              </div>
                            </div>
                          </div>
                          <a
                            href={whatsappLink}
                            target="_blank"
                            rel="noreferrer noopener"
                            className="bg-black font-bold text-white text-sm whitespace-nowrap  px-4 py-2 rounded h-10 mr-6"
                            onClick={() => {
                              handleDataTracker(`${sectionName}-whatsapp-join`);
                            }}
                          >
                            Join Now
                          </a>
                        </div>

                        <div className="block sm:hidden">
                          <div className="flex gap-x-3 items-center ">
                            <img
                              src="https://d2o2utebsixu4k.cloudfront.net/master-class/whatsappMasterClass.png"
                              width="32"
                              height="32"
                              alt="whatsapp"
                            />
                            <div className="text-left">Join our WhatsApp Community</div>
                          </div>
                          <div className="border-t border-[#2b2b2b] pt-2 mt-2 mb-4">
                            Get{' '}
                            <span className="text-[#FFDA15] text-sm leading-[21px]  masterclass-secondary-font">
                              Free
                            </span>{' '}
                            learning resources, course offers, newsletters, updates and future events
                          </div>
                          <a
                            href={whatsappLink}
                            target="_blank"
                            rel="noreferrer noopener"
                            className="bg-white text-black font-bold px-4 py-2 rounded h-10"
                            onClick={() => {
                              handleDataTracker(`${sectionName}-whatsapp-join`);
                            }}
                          >
                            Join Now
                          </a>
                        </div>
                      </div>
                    )}

                    <HeadingContainer>
                      <SuccessIcon>
                        <img
                          src="https://d2o2utebsixu4k.cloudfront.net/assets/images/icons/form-green-tick.gif"
                          width="100"
                          height="100"
                        />
                      </SuccessIcon>
                      <Heading
                        className={`${
                          whatsappLink
                            ? 'md:text-[20px] md:leading-[26px]  text-[14px] leading-[21px]'
                            : 'text-base leading-[22px]'
                        }`}
                      >
                        Hurray! You just set yourself up for success. Good job! 😊
                      </Heading>
                      <SubHeading
                        className={`${
                          whatsappLink
                            ? 'text-[12px] leading-[18px] md:text-[14px] md:leading-4 text-[#6B7580] md:text-[#333333]'
                            : 'text-[13px] leading-4 text-[#111]'
                        }`}
                      >
                        Our Learning Advisor will get in touch with you soon.
                      </SubHeading>
                    </HeadingContainer>
                    {(linkedin || telegram) && (
                      <>
                        <div className="border-b border-[#dddddd] mt-4 md:mb-7 mb-6 "></div>

                        <SocialContainer
                          className={`${whatsappLink ? 'flex-col sm:flex-row mb-10 md:mb-0' : 'flex-col'}`}
                        >
                          <SocialText
                            className={`${
                              whatsappLink
                                ? 'text-[12px] leading-[18px] md:leading-4 md:text-[14px] text-[#6B7580] md:text-[#333333]'
                                : ' text-xs text-[#111]'
                            }`}
                          >
                            To receive notifications and important updates on the course, follow us:
                          </SocialText>
                          <IconContainer>
                            {/* Linkedin icon */}
                            {linkedin && (
                              <a href={linkedin} target="_blank" rel="noopener noreferrer nofollow">
                                <div>
                                  <img
                                    src="https://d2o2utebsixu4k.cloudfront.net/assets/images/icons/form-linkedin.png"
                                    width="24"
                                    height="24"
                                  />
                                </div>
                              </a>
                            )}

                            {telegram && (
                              <a href={telegram} target="_blank" rel="noopener noreferrer nofollow">
                                <div>
                                  <img
                                    src="https://d2o2utebsixu4k.cloudfront.net/assets/images/icons/form-telegram.svg"
                                    width="24"
                                    height="24"
                                  />
                                </div>
                              </a>
                            )}
                          </IconContainer>
                        </SocialContainer>
                      </>
                    )}
                  </Container>
                </Popup>
              </Transition.Child>
            </PopupContainer>
          </MasterClassContainer>
        </div>
      </Transition.Root>
    </div>
  );
};

export default SuccessPopup;
